/**
 * Centralised typed environment variable reads for the frontend bundle.
 *
 * Every frontend `process.env.*` reference must come from this module.
 * CRA inlines `process.env.REACT_APP_*` at build time — these values are
 * baked into the JS bundle when `npm run build` runs, NOT read at runtime.
 *
 * Frozen files (`api.ts`, `App.tsx`, `AuthContext.tsx`, `AppShell.tsx`)
 * intentionally still read `process.env` directly per `operating-rules.md` §4.
 * Future tickets that unlock those files should migrate them through here.
 */

/** Backend API base URL. Defaults to '/api' so unfrozen call sites work both
 *  in dev (CRA proxy in `frontend/package.json` forwards `/api` to
 *  localhost:3001) and on Railway (backend + frontend served from the same
 *  origin). The frozen `api.ts` keeps its own 'http://localhost:3001' fallback
 *  for the file-download helper that needs an absolute origin. */
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || '/api';

/** WebSocket URL. */
export const REACT_APP_WS_URL = process.env.REACT_APP_WS_URL || '';

/** Feature flag for MMS in the Twilio softphone. Existing call-sites use
 *  `!env.REACT_APP_MMS_ENABLED` (truthy = enabled), so preserve the raw
 *  string rather than coercing to boolean. */
export const REACT_APP_MMS_ENABLED = process.env.REACT_APP_MMS_ENABLED || '';

/** CRA-standard public path. Used by `serviceWorkerRegistration.ts` to
 *  resolve the SW file's URL. */
export const PUBLIC_URL = process.env.PUBLIC_URL || '';
